import path from 'path-browserify';

import { getBaseUrl } from '@api/base-url';
import { ENDPOINTS } from '@constants/api-constants';

const base = (): string => path.join(getBaseUrl({ version: 1 }), 'auth/');

const urls = Object.freeze({
  emailAvailability: (): string => path.join(
    base(),
    'email/availability/',
  ),
  emailVerificationCode: (): string => path.join(
    base(),
    'email/code/verification/',
  ),
  passwordReset: (): string => path.join(
    base(),
    'password-reset/',
  ),
  passwordResetCode: (): string => path.join(
    base(),
    'email/code/password-reset/',
  ),
  ssoAuthorizationUrl: (): string => path.join(
    base(),
    'sso/authorization-url/',
  ),
  ssoEnablementStatus: (): string => path.join(
    base(),
    'sso/enablement/status/',
  ),
  tokenPair: (): string => path.join(
    base(),
    'token/pair/',
  ),
  tokenRefresh: (): string => path.join(
    base(),
    ENDPOINTS.V1.REFRESH_TOKEN,
  ),
  tokenRevoke: (): string => path.join(
    base(),
    'token/revoke/',
  ),
});

export default urls;
